const formatNumber = (value) => {
  return (+value || 0).toFixed(2).replace(/[.,]00$/, '')
}

export default formatNumber
